const twilioInstance = {};
export default twilioInstance;



// WEBPACK FOOTER //
// ./src/twilioInstance.js